import { render, staticRenderFns } from "./PanelOrganizerHeader.vue?vue&type=template&id=86326fb0&scoped=true&"
import script from "./PanelOrganizerHeader.vue?vue&type=script&lang=js&"
export * from "./PanelOrganizerHeader.vue?vue&type=script&lang=js&"
import style0 from "./PanelOrganizerHeader.vue?vue&type=style&index=0&id=86326fb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86326fb0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('86326fb0')) {
      api.createRecord('86326fb0', component.options)
    } else {
      api.reload('86326fb0', component.options)
    }
    module.hot.accept("./PanelOrganizerHeader.vue?vue&type=template&id=86326fb0&scoped=true&", function () {
      api.rerender('86326fb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PanelOrganizerHeader.vue"
export default component.exports